import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './portalsNotificationsCard.module.scss';

function AlertErrorsIndicator({ errors, alerts, portalId }) {
  const showAlert = alerts > 0;
  const showError = errors > 0;

  const portalRedirect = (type) => {
    if (!portalId) return;
    const tokkoHost = localStorage.getItem('tokkoBrokerHost');
    window.open(
      `${tokkoHost}/portals/publications/${portalId}/?show_${type}=true`,
      '_blank'
    );
  };
  return (
    <Box className={styles.alertErrorsIndicator}>
      {showAlert && (
        <Box
          className={styles.alertContainer}
          onClick={() => portalRedirect('alerts')}
        >
          <Icon fontSize="12px" icon="icon-alerta_round" />
          <Text variant="body.fontSize12">{alerts}</Text>
        </Box>
      )}
      {showError && (
        <Box
          className={styles.errorContainer}
          onClick={() => portalRedirect('errors')}
        >
          <Icon icon="icon-error" fontSize="12px" />
          <Text variant="body.fontSize12">{errors}</Text>
        </Box>
      )}
    </Box>
  );
}

export default AlertErrorsIndicator;
